<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>

    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-7 text-center pt-lg">
            <img
              v-if="showLogo"
              src="img/brand/white.png"
              style="width: 200px"
              class="img-fluid"
            />
            <p :class="`display-2 text-white mt-4 mb-4`">
              {{ title }}
            </p>
            <p class="text-white mb-5">
              {{ description }}
            </p>

            <div v-if="showBtnBack" class="text-center">
              <base-button
                type="primary"
                class="my-4"
                @click="$router.push(backRoute)"
                >Voltar</base-button
              >
            </div>
          </div>
        </div>
        <div
          class="row align-items-center justify-content-around stars-and-coded"
        ></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: `Desenvolvedor e Analista, Formado na Faculdade de Informática de Presidente Prudente - Unoeste`,
    },
    description: {
      type: String,
      default: "",
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    showBtnBack: {
      type: Boolean,
      default: false,
    },
    backRoute: {
      type: String,
      default: "",
    },
  },
};
</script>
<style>
</style>
